import { createResource, createEndpoint } from './Schema';
import { FriendshipRequestModel } from './Schema/Models';
import api from './Schema/Api';

/*
 * static s'applique au model
 * methods s'applique à la resource
 */
const sync = false;
const methods = {};

const FriendshipRequestResource = createResource(api, FriendshipRequestModel, {
  static: { sync },
  methods,
});

export const FriendshipRequest = createEndpoint(FriendshipRequestResource, '', {
  static: {},
});
